import { Component, Input, OnInit, SkipSelf } from '@angular/core';
import { ControlContainer } from '@angular/forms';
import { FormControlOption } from '@app/forms/subscription/definition/interface/formControlOption.interface';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

@Component({
    selector: 'ea-subscription-floor-guarantee',
    templateUrl: './ea-subscription-floor-guarantee.component.html',
    styleUrls: ['./ea-subscription-floor-guarantee.component.scss'],
    viewProviders: [
        {
            provide: ControlContainer,
            useFactory: (container: ControlContainer) => container,
            deps: [[new SkipSelf(), ControlContainer]],
        },
    ],
    standalone: false
})
export class EaSubscriptionFloorGuaranteeComponent implements OnInit {
  @Input() derrors;
  option: FormControlOption = {
    label: 'Versement initial',
    value: 'initial',
    suffix: 'A',
    svg: 'money1.svg',
  };
  isPer = false;

  constructor(private subscriptionFacade: SubscriptionFacadeService) {}

  ngOnInit() {
    this.isPer = this.subscriptionFacade.getPledge()?.productType === 'PER';
  }
}
